import Button from 'components/shared/Button/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

/**
 * A reusable confirmation modal for onboarding wizard substeps.
 * Shown when a user tries to continue without completing the required action
 * (e.g., no payers added, no facilities added, no kiosks registered, etc.).
 *
 * Provides three actions:
 * - Mark complete: marks the substep as done even without data
 * - Skip for now: moves to the next substep without marking complete
 * - Primary action: dismisses the modal so the user can complete the step
 */
const SubstepConfirmationModal = ({
  isOpen,
  onClose,
  onMarkComplete,
  onSkip,
  primaryActionText = null,
  onPrimaryAction = null,
  title,
  message,
  isLoading = false
}) => {
  return (
    <Confirm
      isOpen={isOpen}
      handleClose={onClose}
      handleContinue={() => {}}
      title={title}
      message={message}
      icon="info-filled"
      iconColor="primary"
      footer={
        <>
          <Button
            text="Mark complete"
            size="small"
            color="danger"
            variant="link"
            onClick={onMarkComplete}
            isDisabled={isLoading}
          />
          <Button
            text="Skip for now"
            size="small"
            style="outlined"
            color="neutral"
            onClick={onSkip}
            isDisabled={isLoading}
          />
          {primaryActionText && (
            <Button
              text={primaryActionText}
              size="small"
              onClick={onPrimaryAction || onClose}
              isDisabled={isLoading}
            />
          )}
        </>
      }
    />
  );
};

export default SubstepConfirmationModal;
